// removed by extract-text-webpack-plugin
module.exports = {"card":"_3mE6iyyhc3lMC89gtTeckf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DebtPhaseMbReference/styles.css
// module id = 1067
// module chunks = 0